// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"wrapper_wrapper__Bd4jZ","container":"wrapper_container__FIdI3","slimContainer":"wrapper_slimContainer__p_1_1","wrapperFullHeight":"wrapper_wrapperFullHeight__uhjdO"};